import * as tslib_1 from "tslib";
/* I37 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Eye = function (props) {
    return (React.createElement(IconWrap, tslib_1.__assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", null,
                React.createElement("path", { d: "M12 5C7 5 2.73 8.11 1 12.5 2.73 16.89 7 20 12 20s9.27-3.11 11-7.5C21.27 8.11 17 5 12 5zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" })))));
};
Eye.displayName = 'Eye';
export default Eye;
//# sourceMappingURL=Eye.js.map